<template>
  <div class="toolsOverview">
    <div class="toolsOverview-content content">
      <div class="toolsOverview-content-image">
        <a>
          <img :src="imageFile" alt="">
        </a>
      </div>
      <div class="toolsOverview-content-details">
        <p class="toolsOverview-content-details-name">{{ name }}</p>
        <p class="toolsOverview-content-details-version">Ver {{ version }} [ {{releaseDate}} - {{updateDate}} ]</p>
        <p class="toolsOverview-content-details-summary">{{ summary }}</p>
        <hr>
        <div v-for="item in description" :key="item.id" class="toolsOverview-content-details-description">
          {{ item }}
        </div>
        <div class="toolsOverview-content-details-link">
          <a :href="link" target="_blank">{{ linkButtonName }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['name', 'summary', 'releaseDate', 'updateDate',
    'version', 'imageFile', 'linkButtonName', 'link', 'description'],
  data () {
    return {
      show: false
    }
  }
}
</script>

<style scoped lang="scss">
@import './../styles/definitions.scss';
.toolsOverview {
  background-color: $kHeaderColorMain;
  height: auto;
  min-height: 240px;
  margin: 10px 0px 10px 0px;
  @media (max-width: $MobileWidth) {
  }
  &-content {
    position: relative;
    display: flex;
    top: 5%;
    width: 80%;
    height: 95%;
    min-height: 240px;
    border-radius: 4px;
    background-color: $kOverViewColorMain;
    color: #ffffff;
    &-image {
      width: 240px;
      img {
        padding: 5% 5% 5% 5%;
        object-fit: cover;
      }
    }
    &-details {
      margin-left: auto;
      margin-right: auto;
      color: #ffffff;
      width: 80%;
      &-name {
        font-size: 32px;
        font-weight: bold;
        margin: 0px;
      }
      &-version {
        margin: 0px;
      }
      &-summary {
        padding: 0px 0px 0px 20px;
        margin: 0px;
      }
      hr {
        width: 98%;
        border: none;
        border-bottom: 2px #6767be solid;
        margin: 0px 0px 10px 0px;
      }
      &-description {
        font-size: 14px;
        padding: 0px 0px 0px 0px;
        margin: 0px;
      }
      &-link {
        margin-top: 10px;
        margin-bottom: 10px;
        margin-left: auto;
        margin-right: auto;
        a {
          margin-left: 10px;
          padding: 0.25em 0.7em;
          text-decoration: none;
          color: #FFF;
          background: rgb(46, 148, 196);
          border-radius: 3px;
          transition: 0.2s;
          &:hover {
            background: rgb(93, 188, 231);
          }
        }
      }
    }
    @media (max-width: $MobileWidth) {
      flex-direction: column;
      text-align: center;
      height: auto;
      &-image {
        width: 100%;
        img {
          padding: 5% 5% 5% 5%;
          width: 250px;
          height: 220px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/toolOverview.vue